<template>
  <div>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="'日期'">
              <a-range-picker
                v-model='queryParam.queryDate'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'类型'">
              <a-select
                v-model='queryParam.type'
              >
                <a-select-option value='payout'>放款</a-select-option>
                <a-select-option value='repay'>还款</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'盘号'">
              <a-select
                v-model='queryParam.appssid'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="前收后收">
              <a-select default-value="" style="width: 120px" v-model="queryParam.receiptTimeFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  前收
                </a-select-option>
                <a-select-option value="1">
                  后收
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                          <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                          <a-button type='primary' @click='searchReset' icon='reload'
                                    style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>

    </div>

  </div>
</template>


<script>

import { filterObj } from '@/utils/util'
import moment from 'moment'
import { getApplist } from '@/webpublicapi/order'
import {
  groupApplyProductByDate

} from '@/webpublicapi/statistics'

const I18N_KEY = {}


export default {
  name: 'groupApplyProductByDate',

  data() {
    return {
      loading: false,
      dataSource: [],
      appList: [],
      queryParam: {
        receiptTimeFlag: '',
        queryDate: [moment(), moment()],
        appssid: '',
        type: 'payout'
      }
    }

  },

  computed: {
    columns() {
      return [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'date'
        },
        {
          title: '新 720',
          align: 'left',
          dataIndex: 'new_product_720'
        },
        {
          title: '新 725',
          align: 'left',
          dataIndex: 'new_product_725'
        },
        {
          title: '新 730',
          align: 'left',
          dataIndex: 'new_product_730'
        },
        {
          title: '新 735',
          align: 'left',
          dataIndex: 'new_product_735'
        },
        {
          title: '新 740',
          align: 'left',
          dataIndex: 'new_product_740'
        },
        {
          title: '新 other',
          align: 'left',
          dataIndex: 'new_product'
        },
        {
          title: '老 720',
          align: 'left',
          dataIndex: 'old_product_720'
        },
        {
          title: '老 725',
          align: 'left',
          dataIndex: 'old_product_725'
        },
        {
          title: '老 730',
          align: 'left',
          dataIndex: 'old_product_730'
        },
        {
          title: '老 735',
          align: 'left',
          dataIndex: 'old_product_735'
        },
        {
          title: '老 740',
          align: 'left',
          dataIndex: 'old_product_740'
        },
        {
          title: '老 other',
          align: 'left',
          dataIndex: 'old_product'
        }
      ]
    }
  },
  created() {
    getApplist().then(res => {
      this.appList = res.data || []
      if (this.appList.length && this.appList.length >= 1) {
        this.appList.shift()
      }
    })
    this.loadData()
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    loadData() {
      this.loading = true
      let params = this.getQueryParams()// 查询条件

      groupApplyProductByDate(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.dataSource = [];
          this.setData(res.data,params.type)
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    setData(sourceData,type) {
      if (!sourceData)
        return

      for (let date in sourceData) {

        let dateProducts = sourceData[date]

        dateProducts = Object.values(dateProducts)

        let newTotal = 0
        let oldTotal = 0
        for (let i = 0; i < dateProducts.length; i++) {

          if (dateProducts[i].type == 'new')
            newTotal += dateProducts[i].count
          else
            oldTotal += dateProducts[i].count
        }

        let dateProduct = {}
        dateProduct.date = date
        let otherNew = 0
        let otherOld = 0
        let otherNewRepay = 0
        let otherOldRepay = 0
        for (let i = 0; i < dateProducts.length; i++) {


          if (dateProducts[i].product == 'product_720' || dateProducts[i].product == 'product_725' || dateProducts[i].product == 'product_730' || dateProducts[i].product == 'product_735' || dateProducts[i].product == 'product_740') {
            let key = dateProducts[i].type + '_' + dateProducts[i].product
            if(type == 'repay')
            {
              dateProduct[key] = this.getRateStringRepay(dateProducts[i].countRepay, dateProducts[i].count)
            }else
              dateProduct[key] = this.getRateString(dateProducts[i].count, dateProducts[i].type == 'new' ? newTotal : oldTotal)
          } else {
            if (dateProducts[i].type == 'new')
            {
              otherNew += dateProducts[i].count
              if(type == 'repay')
                otherNewRepay += dateProducts[i].countRepay
            }
            else
            {
              otherOld += dateProducts[i].count
              if(type == 'repay')
                otherOldRepay += dateProducts[i].countRepay
            }
          }
        }

        if (otherNew > 0)
        {
          if(type == 'repay')
            dateProduct['new_product'] = this.getRateStringRepay(otherNewRepay, otherNew)
          else
            dateProduct['new_product'] = this.getRateString(otherNew, newTotal)
        }

        if (otherOld > 0)
        {
          if(type == 'repay')
            dateProduct['old_product'] = this.getRateStringRepay(otherOldRepay, otherOld)
          else
            dateProduct['old_product'] = this.getRateString(otherOld, oldTotal)
        }

        console.log(dateProduct)
        this.dataSource.push(dateProduct)
      }
    },
    getRateString(value, total) {
      let rate = ((value / total) * 100).toFixed(2) + '%'
      return rate + '(' + value + ')'
    },
    getRateStringRepay(value, total) {
      let rate = ((value / total) * 100).toFixed(2) + '%'
      return rate + '(' + value + '/' + total + ')'
    },
    getQueryParams() {

      const { queryDate } = this.queryParam

      const data = {
        ...this.queryParam,//...将原始的this.queryParam对象中的属性复制到data对象中
        startDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[0]) : undefined,
        endDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[1]) : undefined
      }

      let param = this.queryParam

      param = Object.assign(data)

      return filterObj(param)
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      let that = this
      that.queryParam.receiptTimeFlag = ''
      that.queryParam.appssid = ''
      that.queryParam.type = 'payout'
      that.queryParam.endDate = ''
      that.queryParam.startDate = ''
      that.queryParam.queryDate = [moment(), moment()]
    }

  }
}
</script>

<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>